module.exports = __webpack_public_path__ + "static/media/UnionPay.9ef6b610.svg";